/**
 * ManageChannelsButtonsContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';

/**
 * Styled manage channels buttons container.
 */
const ManageChannelsButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  position: relative;
  right: ${52 * Screen.widthRatio}px;
  top: ${64 * Screen.widthRatio}px;
  transform: scale(0.9);
  transform-origin: 0 0;
  width: ${1114 * Screen.widthRatio}px;
`;

export default ManageChannelsButtonsContainer;
